export const SECTION_HERO_I18N_EN = {
    title: "Popular Search",
    tagsAriaLabel: "Popular search keywords",
    adLabel: "Advertisement",
    adText: "Advertisement",
    searchBaseUrl: "/home/en/index.php?q=",
    popularKeywordsApiUrl: "/api/home/en/popular-keywords.php",
    popularKeywordClickApiUrl: "/api/home/en/popular-keywords-click.php",
};
